import API from "../api";
import * as URLS from "../constants/api";

export async function getPaginatedDepartment(page, perPage, filters = {}, sort = {}) {
  const headers = {
    "Content-Type": "application/json; charset=UTF-8",
  };
  try {
    const data = {
      page: page,
      per_page: perPage,
      ...filters,
      sort:sort,
    };
    const response = await API.get(
      URLS.API_DEPARTMENTS,
      { params: data },
      {
        headers,
      }
    );
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

export async function submitDepartment(data, id=null) {
  const headers = {
    "Content-Type": "application/json; charset=UTF-8",
  };
  try {
    let url = URLS.API_DEPARTMENTS;
    if (id) {
      url = URLS.API_DEPARTMENTS + `/id/${id}`;
    }
    
    let response = await API.post(
      url,
      JSON.stringify(data), 
      { headers: headers }
    );
    return response.data;
  } catch (e) {
    throw e.response
  }
}

export async function deleteDepartment(ids) {
  const headers = {
    "Content-Type": "application/json; charset=UTF-8",
  };
  try {
    let url = URLS.API_DEPARTMENTS
    
    let response = await API.delete(
      url,{
        headers: headers,
        data: {
          ids: ids
        }
      }
    );
    return response.data;
  } catch (e) {
    throw e.response
  }
}


